// utils.js
import _ceil from 'lodash/ceil';
import _round from 'lodash/round';

import { calculateDobPerLocation, formulateChartUrl, formulateGenderFromUrlFragment } from './intermediary_url_service';
import {
  calculateAgeInMonthsWithTwoDates,
  calculateZScore,
  convertInchesToCms,
  parseUrlForSimpleChartType,
} from './lm_utilities';
import { getAgeDesc, getLifeStage } from './lm_title_description_service';
import {
  getXAxisPointsFor0To24Months,
  getXAxisPointsFor21To100Years,
  getXAxisPointsFor2To20Years,
} from './data_points_service';
import { plural } from 'pluralize';
import { parseUrlForGenderWithString } from './maps';
import { stripLocalePrefixFromPath } from './seo';
import { normalizeLocaleForImage } from './normalizeLocaleForImage';
import safeWindow from './safeWindow';

export const initialUnit = (type) => {
  let unit = 'USD';
  // if (type === 'weight') unit = 'lbs';
  // if (type === 'bmi') unit = 'cms-kgs';

  return unit;
};
export const setInitialState = (pathname, localStorageData, type) => {
  const path = pathname;
  const parts = path.split('/'); // get gender form url
  const gender = parts[2];
  let freshForm = {
    gender: formulateGenderFromUrlFragment(gender),
    dob: calculateDobPerLocation(pathname).toLocaleDateString('en-CA'),
    md: new Date().toLocaleDateString('en-CA'),
    unit: initialUnit(type),
    in_kgs: 0,
    in_lbs: 0,
    in_cms: 0,
    in_incs: 0,
    l_measurement: type === 'weight' ? 25.1 : 75.5,
    l_height_ft: 0,
    l_height_in: 0,
    member_id: null,
  };

  if (type === 'bmi') {
    freshForm.w_measurement = 11.2;
  }

  let tempForm = localStorageData ? JSON.parse(localStorageData) : freshForm;
  let temp_age = _ceil(calculateAgeInMonthsWithTwoDates(tempForm.dob, tempForm.md));
  let tempUrl = formulateChartUrl(tempForm, `${type}-charts`, temp_age);

  if (tempUrl === pathname) return tempForm;
  else {
    freshForm.gender = tempForm ? tempForm.gender : freshForm.gender;
    freshForm.dob = tempForm ? tempForm.dob : freshForm.dob;
    freshForm.member_id = tempForm ? tempForm.member_id : freshForm.member_id;
    return freshForm;
  }
};

export const getBlurbData = (unit, data, pathname, locale = 'en-US') => {
  let formatted = data;
  if (data) {
    // if (unit === 'inches')
    //   formatted = {
    //     percentile_3: _round(parseFloat(_round(data.p_3, 2) * 0.393701), 1),
    //     percentile_97: _round(parseFloat(_round(data.p_97 || data.p_95, 2) * 0.393701), 1),
    //     percentile_2: _round(parseFloat(_round(data.p_2, 2) * 0.393701), 1),
    //     percentile_98: _round(parseFloat(_round(data.p_98, 2) * 0.393701), 1),
    //     percentile_50: _round(parseFloat(_round(data.p_50, 2) * 0.393701), 1),
    //     ageDesc: pathname ? getAgeDesc(pathname) : getAgeDesc(window.location.pathname),
    //   };
    // else if (unit === 'lbs')
    //   formatted = {
    //     percentile_3: _round(parseFloat(_round(data.p_3, 2) * 2.20462), 1),
    //     percentile_97: _round(parseFloat(_round(data.p_97 || data.p_95, 2) * 2.20462), 1),
    //     percentile_2: _round(parseFloat(_round(data.p_2, 2) * 2.20462), 1),
    //     percentile_98: _round(parseFloat(_round(data.p_98, 2) * 2.20462), 1),
    //     percentile_50: _round(parseFloat(_round(data.p_50, 2) * 2.20462), 1),
    //     ageDesc: pathname ? getAgeDesc(pathname) : getAgeDesc(window.location.pathname),
    //   };
    // else
    formatted = {
      percentile_3: _round(data.p_3, 2),
      percentile_97: _round(data.p_97 || data.p_95, 2),
      percentile_2: _round(data.p_2, 2),
      percentile_98: _round(data.p_98, 2),
      percentile_50: _round(data.p_50, 2),
      ageDesc: pathname ? getAgeDesc(pathname, locale) : getAgeDesc(stripLocalePrefixFromPath(safeWindow.location.pathname), locale),
    };
  } else {
    formatted = {
      percentile_3: '',
      percentile_97: '',
      percentile_2: '',
      percentile_98: '',
      percentile_50: '',
    };
  }

  return formatted;
};

// export const getBlurbData = (unit, data, pathname) => {
//   if (!data) {
//     return {
//       percentile_3: '',
//       percentile_97: '',
//       percentile_2: '',
//       percentile_98: '',
//       percentile_50: '',
//     };
//   }

//   const factor = unit === 'inches' ? 0.393701 : unit === 'lbs' ? 2.20462 : null;

//   const convert = (val) => (typeof val === 'number' ? (factor ? _round(val * factor, 1) : _round(val, 2)) : '');

//   return {
//     percentile_3: convert(data.p_3),
//     percentile_97: convert(data.p_97 ?? data.p_95), // <--- Use nullish coalescing directly
//     percentile_2: convert(data.p_2),
//     percentile_98: convert(data.p_98),
//     percentile_50: convert(data.p_50),
//     ageDesc: getAgeDesc(pathname || window.location.pathname),
//   };
// };

export const getAxisPoints = (options, calculated_age) => {
  // if (calculated_age <= 24 || (calculated_age > 24 && calculated_age < 25)) {
  //   options.xAxisPoints = getXAxisPointsFor0To24Months();
  //   options.xAxistickInterval = 2;
  //   options.yAxistickInterval = 2;
  //   options.plotBandWidth = 1;
  // } else if (calculated_age >= 288 && calculated_age <= 1200) {
  options.xAxisPoints = getXAxisPointsFor21To100Years();
  options.xAxistickInterval = 2;
  options.yAxistickInterval = 2;
  options.plotBandWidth = 1;
  // } else {
  //   options.xAxisPoints = getXAxisPointsFor2To20Years();
  //   options.xAxistickInterval = 1;
  //   options.yAxistickInterval = 20;
  //   options.plotBandWidth = 5;
  // }

  return options;
};

export const calculatePercentileWithZscores = (floorData, ceilData, calculated_age, floor, ceil, value) => {
  const box_cox = floorData.charts[0]?.box_cox;
  const median = floorData.charts[0].median;
  const coff = floorData.charts[0].coefficient;
  const zScore1 = calculateZScore(value, box_cox, median, coff);

  const box_cox_ceil = ceilData.charts[0]?.box_cox;
  const median_ceil = ceilData.charts[0].median;
  const coff_ceil = ceilData.charts[0].coefficient;
  const zScore2 = calculateZScore(value, box_cox_ceil, median_ceil, coff_ceil);

  return ((calculated_age - floor) * (zScore2 - zScore1)) / (ceil - floor) + zScore1;
};
export const calculatePercentileLinear = (floorData, ceilData, calculated_age, floor, ceil, value) => {
  const floorChart = floorData.charts[0];
  const ceilChart = ceilData.charts[0];

  // take percentiles from 2–99
  const percentiles = [
    'p_2',
    'p_3',
    'p_5',
    'p_10',
    'p_25',
    'p_50',
    'p_75',
    'p_80',
    'p_85',
    'p_90',
    'p_95',
    'p_97',
    'p_98',
    'p_99',
  ];

  // find nearest percentiles around the given value at floor and ceil
  const getPercentileAtAge = (chart, val) => {
    let lastKey = 'p_2';
    for (let key of percentiles) {
      if (val < chart[key]) {
        return key; // first percentile bucket above the value
      }
      lastKey = key;
    }
    return 'p_99';
  };

  const pFloor = getPercentileAtAge(floorChart, value);
  const pCeil = getPercentileAtAge(ceilChart, value);

  // extract the numeric percentile (strip "p_")
  const numPFloor = parseInt(pFloor.split('_')[1]);
  const numPCeil = parseInt(pCeil.split('_')[1]);

  // linear interpolation by age
  const percentile = ((calculated_age - floor) * (numPCeil - numPFloor)) / (ceil - floor) + numPFloor;

  return percentile;
};

// export const calculatePercentileWithZscores = (floorData, ceilData, calculated_age, floor, ceil, value) => {
//   const roundedValue = Math.round(value * 1000) / 1000;
//   const box_cox = floorData.charts[0].box_cox;
//   const median = floorData.charts[0].median;
//   const roundedMedian = Math.round(median * 1000) / 1000;
//   const coff = floorData.charts[0].coefficient;
//   const zScore1 = calculateZScore(roundedValue, box_cox, roundedMedian, coff);

//   const box_cox_ceil = ceilData.charts[0].box_cox;
//   const median_ceil = ceilData.charts[0].median;
//   const roundedMedian_ceil = Math.round(median_ceil * 1000) / 1000;
//   const coff_ceil = ceilData.charts[0].coefficient;
//   const zScore2 = calculateZScore(roundedValue, box_cox_ceil, roundedMedian_ceil, coff_ceil);
//   console.log('value:', value, 'median:', median, 'equals?', roundedValue === median);
//   console.log('diff:', Math.abs(value - median));
//   return ((calculated_age - floor) * (zScore2 - zScore1)) / (ceil - floor) + zScore1;
// };
export const getValueInCms = (unit, value) => {
  if (unit === 'inches') return convertInchesToCms(value);
};

export const concantQuery = (obj) => {
  if (typeof obj !== 'object' || obj === null) return '';

  const query = Object.keys(obj).reduce((_query, key) => {
    // Explicitly check for undefined and null
    if (obj[key] !== undefined && obj[key] !== null) {
      return _query + `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}&`;
    }
    return _query;
  }, '');

  return query.length > 0 ? '?' + query.replace(/&$/, '') : query;
};
export const base64ToBlob = (base64, mimeType) => {
  const byteCharacters = atob(base64.split(',')[1]);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mimeType });
};

const splitUrlToParts = (pathname) => {
  if (!pathname) return [];

  return pathname.split('/').filter(Boolean);
};
// export const getFileNameServer = (blurbData, hashArray, url) => {
//   try {
//     const urlParts = splitUrlToParts(url);

//     let fileName =
//       hashArray[3] +
//       ' ' +
//       plural(getLifeStage(url)) +
//       ' ' +
//       parseUrlForSimpleChartType(urlParts[0]) +
//       ' ' +
//       parseUrlForGenderWithString(hashArray, locale) +
//       ' chart';

//     fileName = fileName.toLowerCase().replaceAll(' ', '-');

//     return fileName;
//   } catch (e) {
//     console.error('Error generating fileName:', e);
//     return 'default-chart';
//   }
// };
export const getFormattedUTCDate = (date) => {
  const yyyy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yyyy}${mm}${dd}`;
};
export const getFileNameServer = (blurbData, hashArray, url, date = null, locale = 'en-US') => {
  const imageLocale = normalizeLocaleForImage(locale);
  const splitParts = splitUrlToParts(url);

  const baseFileName =
    hashArray[3] +
    ' ' +
    plural(getLifeStage(url, imageLocale)) +
    ' ' +
    parseUrlForSimpleChartType(splitParts[0]) +
    ' ' +
    parseUrlForGenderWithString(hashArray, imageLocale) +
    ' chart';

  const cleanFileName = baseFileName.toLowerCase().replaceAll(' ', '-');

  if (date) {
    const formattedDate = getFormattedUTCDate(date);
    return `${cleanFileName}-${formattedDate}`;
  }

  return cleanFileName;
};
// export const getChartImageAltValueServer = (blurbData, hashArray, url) => {
//   try {
//     const urlParts = splitUrlToParts(url);

//     let fileName =
//       blurbData?.ageDesc +
//       ' ' +
//       plural(getLifeStage(url)) +
//       ' ' +
//       parseUrlForSimpleChartType(urlParts[0]) +
//       ' ' +
//       parseUrlForGenderWithString(hashArray, locale) +
//       ' chart';

//     fileName = fileName.toLowerCase();
//     return fileName;
//   } catch (e) {
//     console.error('Error generating chartImageAltValue:', e);
//     return 'chart'; // optional fallback
//   }
// };
export const getChartImageAltValueServer = (blurbData, hashArray, url, date = null, locale = 'en-US') => {
  // Alt text uses the real viewer locale (translated → screen readers + SEO).
  const splitParts = splitUrlToParts(url); // already safe
  const baseFileName =
    hashArray[3] +
    ' ' +
    plural(getLifeStage(url, locale)) +
    ' ' +
    parseUrlForSimpleChartType(splitParts[0]) +
    ' ' +
    parseUrlForGenderWithString(hashArray, locale) +
    ' chart';

  const cleanFileName = baseFileName.toLowerCase().replaceAll(' ', '-');

  if (date) {
    // Add date in yyyymmdd format
    const formattedDate = getFormattedUTCDate(date);
    return `${cleanFileName}-${formattedDate}`;
  }

  return cleanFileName;
};

// export const checkImageExistsServer = async (fileName) => {
//   const imageUrl = process.env.NEXT_PUBLIC_CHART_IMAGE_URL + fileName + '.png';

//   try {
//     const response = await fetch(imageUrl, { method: 'HEAD' });
//     if (response.ok) {
//       return imageUrl;
//     } else {
//       return null;
//     }
//   } catch (error) {
//     return null;
//   }
// };
export const checkImageExistsServer = async (fileName) => {
  // const transformation = 'c_thumb,g_face,q_auto,f_auto,h_150,w_150';

  const baseUrl = process.env.NEXT_PUBLIC_CHART_IMAGE_URL; // should include /upload/
  const [beforeUpload, afterUpload] = baseUrl.split('/upload');
  const segment = (afterUpload || '').replace(/^\/|\/$/g, '');

  const imageUrl = segment
    ? `${beforeUpload}/upload/${segment}/${fileName}.png`
    : `${beforeUpload}/upload/${fileName}.png`;

  try {
    const response = await fetch(imageUrl, { method: 'HEAD' });
    if (response.ok) {
      return imageUrl;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

// export const getAgeFloorAndCeil = (age) => {
//   if (age <= 24) {
//     return [String(age), String(age)];
//   } else if (age <= 240) {
//     const floor = String(age - 0.5);
//     const ceil = age === 240 ? String(age) : String(age + 0.5);
//     return [floor, ceil];
//   } else if (age > 240) {
//     let newValue = age;
//     const remainder = age % 12;
//     if (remainder > 0) newValue -= remainder;
//     return [String(newValue - 12), String(newValue)];
//   }

//   // return [_floor(age) - 12, _ceil(age) + 12];
// };
// TODO // CODE TO REMOVE ABOVE

export const getAgeFloorAndCeil = (age) => {
  const floor = Math.floor(age);
  const ceil = Math.ceil(age);

  // If age is already an integer, floor and ceil will be the same
  if (floor === ceil) {
    return [String(floor), String(ceil)];
  }

  return [String(floor), String(ceil)];
};

// export const getAgeFloorAndCeil = (age) => {
//   const floor = Math.floor(age);
//   const ceil = floor + 1;
//   return [String(floor), String(ceil)];
// };

// formatAgeDescription deleted — replaced by getAgeDescAdjective in
// lm_title_description_service.js (ICU-based, locale-aware)

// **** NEW PERCENTILE CODE **** ////
const num = (v) => (typeof v === 'string' ? parseFloat(v) : v);

// Percentile keys in order
const P_KEYS = [
  'p_2',
  'p_3',
  'p_5',
  'p_10',
  'p_25',
  'p_50',
  'p_75',
  'p_80',
  'p_85',
  'p_90',
  'p_95',
  'p_97',
  'p_98',
  'p_99',
];

// Build a sorted curve: [{p: 2, v: 18}, ...]
function buildCurve(chart) {
  const curve = [];
  for (const k of P_KEYS) {
    if (k in chart && chart[k] != null) {
      curve.push({ p: parseInt(k.slice(2), 10), v: num(chart[k]) });
    }
  }
  // Ensure strictly increasing by value (sorting helps if data is slightly noisy)
  curve.sort((a, b) => a.p - b.p);
  return curve;
}

// Invert curve using log-space interpolation of values
function invertPercentile(curve, value) {
  const x = num(value);

  // Guard for non-positive values (log not defined). Fall back to linear if needed.
  const useLog = curve.every((pt) => pt.v > 0) && x > 0;

  // Edge: below smallest
  if (x <= curve[0].v) {
    const a = curve[0],
      b = curve[1];
    const t = useLog ? (Math.log(x) - Math.log(a.v)) / (Math.log(b.v) - Math.log(a.v)) : (x - a.v) / (b.v - a.v);
    return a.p + (b.p - a.p) * Math.max(0, Math.min(1, t));
  }
  // Edge: above largest
  if (x >= curve[curve.length - 1].v) {
    return 100;
  }

  // Find segment
  for (let i = 0; i < curve.length - 1; i++) {
    const a = curve[i],
      b = curve[i + 1];
    if (a.v <= x && x <= b.v) {
      const denom = useLog ? Math.log(b.v) - Math.log(a.v) : b.v - a.v;
      const t = denom === 0 ? 0.5 : useLog ? (Math.log(x) - Math.log(a.v)) / denom : (x - a.v) / denom;
      return a.p + (b.p - a.p) * Math.max(0, Math.min(1, t));
    }
  }

  // Should never get here
  return 50;
}

// export function calculatePercentileFromPoints(floorData, ceilData, calculated_age, floor, ceil, value) {
//   const floorChart = floorData.charts[0];
//   const ceilChart = ceilData.charts[0];

//   const curveFloor = buildCurve(floorChart);
//   const curveCeil = buildCurve(ceilChart);

//   const pFloor = invertPercentile(curveFloor, value); // percentile at floor age
//   const pCeil = invertPercentile(curveCeil, value); // percentile at ceil  age

//   const tAge = (num(calculated_age) - num(floor)) / (num(ceil) - num(floor));
//   const p = pFloor + (pCeil - pFloor) * Math.max(0, Math.min(1, tAge));

//   // Optional: clamp nicely
//   return Math.max(0, Math.min(100, p));
// }

//////////////************** */
// export function calculatePercentileFromPoints(floorData, ceilData, calculated_age, floor, ceil, value) {
//   const floorChart = floorData.charts[0];
//   const ceilChart = ceilData.charts[0];

//   const curveFloor = buildCurve(floorChart);
//   const curveCeil = buildCurve(ceilChart);

//   let pFloor = invertPercentile(curveFloor, value);
//   let pCeil = invertPercentile(curveCeil, value);

//   // --- Extrapolation if value is above known max ---
//   const maxValFloor = Math.max(...curveFloor.map((d) => d.data));
//   const maxValCeil = Math.max(...curveCeil.map((d) => d.data));

//   if (value >= maxValFloor) pFloor = 100;
//   if (value >= maxValCeil) pCeil = 100;

//   // interpolate by age
//   const tAge = (num(calculated_age) - num(floor)) / (num(ceil) - num(floor));
//   const p = pFloor + (pCeil - pFloor) * Math.max(0, Math.min(1, tAge));

//   // clamp
//   return Math.max(0, Math.min(100, p));
// }

////////////////////////////********* */
export function calculatePercentileFromPoints(floorData, ceilData, calculated_age, floor, ceil, value) {
  const floorChart = floorData.charts[0];
  const ceilChart = ceilData.charts[0];

  const curveFloor = buildCurve(floorChart);
  const curveCeil = buildCurve(ceilChart);

  const maxValFloor = Math.max(...curveFloor.map((d) => d.data));
  const maxValCeil = Math.max(...curveCeil.map((d) => d.data));

  let pFloor = invertPercentile(curveFloor, value);
  let pCeil = invertPercentile(curveCeil, value);

  // --- force clamp to 100 if value >= max of dataset ---
  if (value >= maxValFloor) pFloor = 100;
  if (value >= maxValCeil) pCeil = 100;

  // interpolate by age
  const tAge = (Number(calculated_age) - Number(floor)) / (Number(ceil) - Number(floor));
  const p = pFloor + (pCeil - pFloor) * Math.max(0, Math.min(1, tAge));

  return Math.max(0, Math.min(100, p));
}
